import { useTranslation } from 'react-i18next';
import Dropdown from 'react-bootstrap/Dropdown';

import { FaAngleDown } from "react-icons/fa6";
import classes from "./styles.module.css";


const LANGUAGES: {
    [key: string]: string
} = {
    ar: "Arabic",
    en: "English",
}

interface LangMenuProp {
    className?: string
}

const LangMenu = ({ className }: LangMenuProp) => {
    const { i18n } = useTranslation();

    const changeLanguageHandle = (lang: string) => {
        i18n.changeLanguage(lang);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }

    return (
        <Dropdown>
            <Dropdown.Toggle id="dropdown-basic"
                className={[classes.lang__btn].join(' ')}
                aria-label="Language Selector"
            >
                {LANGUAGES[i18n.language] || i18n.language.toUpperCase()}
                <FaAngleDown />
            </Dropdown.Toggle>

            <Dropdown.Menu className={classes.lang__dropdown}>
                {Object.entries(LANGUAGES).map(([code, label]) => (
                    <Dropdown.Item key={code} onClick={() => changeLanguageHandle(code)}>
                        {label}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>

        </Dropdown>
    )
}

export default LangMenu;